import React, { useMemo } from "react";
import { DatePicker, ConfigProvider } from "antd";
import { i18, trb } from "../../../Utilities";

import enUS from "antd/lib/locale/en_US";
import ltLT from "antd/lib/locale/lt_LT";
import moment from "moment";
import ruRU from "antd/lib/locale/ru_RU";
import { STORAGE_ITEMS } from "../../../Config";
import { useController } from "react-hook-form";

const getDisabledDate = (current, minDate, maxDate) => {
  if (minDate && maxDate) {
    return !current.isBetween(
      moment(minDate)
        .endOf("day")
        .subtract(1, "day")
        .endOf("day"),
      moment(maxDate).endOf("day"),
      null,
      "[]"
    );
  }
  if (minDate) {
    return current.isSameOrBefore(
      moment(maxDate)
        .subtract(1, "day")
        .endOf("day")
    );
  }
  if (maxDate) {
    return current.isSameOrAfter(moment(maxDate).endOf("day"));
  }
  return undefined;
};

const getLocale = (language) => {
  switch (language) {
    case "ru-RU":
      moment.locale("ru", {
        week: {
          dow: 1
        }
      });
      return ruRU;
    case "lt-LT":
      moment.locale("lt", {
        week: {
          dow: 1
        }
      });
      return ltLT;
    case "en-GB":
      moment.locale("en", {
        week: {
          dow: 1
        }
      });
      return enUS;
    default:
      moment.locale("lt", {
        week: {
          dow: 1
        }
      });
      return ltLT;
  }
};

export const DateFormField = ({
  title,
  error,
  size,
  isClearable,
  optionsLabel,
  className = "",
  maxDate,
  minDate,
  control,
  name,
  ...rest
}) => {
  const language = localStorage.getItem(STORAGE_ITEMS.LANGUAGE);

  const { field, fieldState } = useController({ control, name });

  const locale = useMemo(() => getLocale(language), [language])
  
  const currentFormat = moment.localeData().longDateFormat("L");

  const handleChange = value => {
    if (value) {
      const formatedValue = moment(value).format(currentFormat);
      field.onChange(formatedValue);
      return;
    }
    field.onChange(undefined);
  };

  return (
      <div
        className={`form-field-wrapper row  ${className}`}
      >
        {title && <div className="form-field-title col-12">{title}</div>}
        <div className={`form-field-item col-12 ${error ? "has-error" : ""}`}>
          <ConfigProvider locale={locale}>
            <DatePicker
              {...rest}
              {...field}
              placeholder={trb(i18.Labels.SelectDate)}
              disabledDate={current => getDisabledDate(current, minDate, maxDate)}
              format={currentFormat}
              value={field.value ? moment(field.value) : ""}
              showToday={false}
              onChange={handleChange}
              allowClear={isClearable}
              getPopupContainer={trigger => trigger.parentNode}
              style={{width: '100%'}}
            />
          </ConfigProvider>
          {fieldState?.error?.message && (
            <div className="form-field-error">
              {fieldState.error.message}
            </div>
          )}
        </div>
      </div>
  );
};
